import React, { ReactElement } from 'react';
import { ALERT_STYLE_TYPE } from 'b2b-components/core/components/Alert';
import { useTranslate } from 'b2b-apps/core/i18n/hooks';
import ShoppingCartImg from 'b2b-apps/shop/common/assets/shopping-cart.png';
import ShoppingCartImg2x from 'b2b-apps/shop/common/assets/shopping-cart@2x.png';
import { AddItemsToCartContentDoneContainer, ContentAlert, ContentLoading } from 'b2b-apps/shop/common/components';
import type { Props } from './AddItemsToCartContent.types';

export const AddItemsToCartContent = ({
  addItemsToCartData: { data, hasFailed, isLoaded, isLoading, wasStarted },
  onModalClose,
  onModalConfirmClick,
}: Props): ReactElement => {
  const t = useTranslate();

  return (
    <div>
      {wasStarted && isLoading && (
        <ContentLoading
          src={ShoppingCartImg}
          srcSet={ShoppingCartImg2x}
          title={t('Adding items to cart...')}
        />
      )}

      {isLoaded && (
        <AddItemsToCartContentDoneContainer
          data={data}
          onModalClose={onModalClose}
          onConfirm={onModalConfirmClick}
        />
      )}

      {hasFailed && (
        <ContentAlert
          text={{
            title: t('Error'),
            content: t('An error occurred. Please try again'),
            closeLabel: t('Close'),
          }}
          onClose={onModalClose}
          alertType={ALERT_STYLE_TYPE.error}
        />
      )}
    </div>
  );
};
